const setFieldVisibility = (
    field: HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement,
    visibility: 'visible' | 'hidden'
) => {
    if (field instanceof HTMLSelectElement) {
        const parentElement = field.parentElement as HTMLElement;
        if (visibility === 'visible') {
            parentElement.classList.remove('tw:hidden');
            field.removeAttribute('disabled');
        } else {
            parentElement.classList.add('tw:hidden');
            field.value = '';
            field.setAttribute('disabled', '');
        }
    }
};

export default setFieldVisibility;
